import React from 'react';
import { FormControl, Grid, MenuItem } from '@material-ui/core';
import Select from '@material-ui/core/Select';
import { Option } from '../../../components/form-simple-autocomplete/FormSimpleAutoComplete';
import { MediaListStyles } from './styles';
import { CheckIcon } from '../../../components/icon/solid';

type Props = {
  sortingValue: number;
  sortOptions: Option[];
  onSort: (e: React.SyntheticEvent<EventTarget>) => void;
};

const MediaSortSelect = ({ sortingValue, sortOptions, onSort }: Props) => {
  const classes = MediaListStyles();

  return (
    <Grid item xs={12} className={classes.sortSelect}>
      <FormControl variant="outlined">
        <Grid container className={classes.selectContainer}>
          <Grid container alignItems="center">
            <span className={classes.label}>Sort by:</span>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={sortingValue}
              onChange={onSort}
              className={classes.selectMenu}
            >
              {sortOptions.map((item) => (
                <MenuItem
                  key={item.id}
                  value={item.id}
                  classes={{
                    selected: classes.selectedMenuItem,
                  }}
                >
                  <Grid container alignItems="center">
                    {item.id === sortingValue ? <CheckIcon className={classes.checkIcon} />
                      : <div className={classes.checkIcon} />}
                    <span>{item.label}</span>
                  </Grid>
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>
      </FormControl>
    </Grid>
  );
};

export default MediaSortSelect;
